//src/hooks/useDashboard.ts
import { useQuery } from "@tanstack/react-query";
import { getDashboardOverview } from "@/services/dashboard";

export function useDashboardOverview(inventoryId?: string) {
  return useQuery({
    queryKey: ["dashboard_overview", inventoryId || "all"],
    queryFn: () => getDashboardOverview(inventoryId),
    staleTime: 15_000,
  });
}
